import React from 'react';
import { Link } from 'gatsby';
import classNames from 'classnames';

import { WidthContainer, PaddingContainer } from '@components';
import { UnderlinedHeader } from '@components/typographies';
import { Arrow } from '@components/icons';

import * as styles from './Header.module.scss';

export const Header: React.FC = () => {
	return (
		<PaddingContainer
			className={classNames(styles.wrapper, 'white-bg relative')}
		>
			<WidthContainer>
				<UnderlinedHeader
					subtitleClassName="font-400"
					subtitle="Software, Hardware &amp; Firmware Development Services"
				>
					Custom Software Development
				</UnderlinedHeader>
				<div
					className={classNames(styles.callToAction, 'justify-content-center')}
				>
					<Link
						to="#technologies"
						className="d-flex flex-column align-items-center"
					>
						<span>See technologies</span>
						<Arrow width={1} height={25} animation="bounce" />
					</Link>
				</div>
			</WidthContainer>
		</PaddingContainer>
	);
};
